/**
 * Griff zum Verschieben eines Listeneintrags. Ziehen mit Maus oder Finger,
 * oder mit dem Fokus auf dem Griff die Pfeiltasten nach oben und unten.
 */
import type { ComponentProps } from 'react';
import { texts } from '../texts/de.ts';
import { AppIcon } from './AppIcon.tsx';

/** Eigenschaften des Griffs: die Ereignisse aus useDragReorder und eine Beschriftung. */
export interface DragHandleProps extends Omit<ComponentProps<'button'>, 'type' | 'children'> {
  /** Was verschoben wird, für Screenreader. */
  readonly label: string;
}

/** Griff zum Verschieben. */
export function DragHandle({ label, className = '', ...rest }: DragHandleProps) {
  return (
    <button
      type="button"
      aria-label={`${label}: ${texts.common.dragHandle}`}
      title={texts.common.dragHandle}
      className={`cursor-grab rounded-lg p-1.5 text-content-muted select-none hover:bg-surface-sunken active:cursor-grabbing print:hidden ${className}`}
      {...rest}
    >
      <AppIcon name="grip" size={18} />
    </button>
  );
}
